module.exports = __webpack_public_path__ + "static/media/iphone_screen2.96804bf2.png";